import { css } from "@emotion/css";
import { Button, SearchInput } from "@octopusdeploy/design-system-components";
import { themeTokens } from "@octopusdeploy/design-system-tokens";
import { useState, useEffect } from "react";
import { JSONTree } from "./JSONTree";
import type { ShouldExpandNodeInitially } from "./types";
export function ColorTokenViewer() {
    const [expandAll, setExpandAll] = useState(false);
    const [treeKey, setTreeKey] = useState(0);
    const [expandAllTrigger, setExpandAllTrigger] = useState(0);
    const [collapseAllTrigger, setCollapseAllTrigger] = useState(0);
    const [filterValue, setFilterValue] = useState("");
    // Force re-render when expand/collapse state changes or filter changes
    useEffect(() => {
        setTreeKey((prev) => prev + 1);
    }, [expandAll, expandAllTrigger, collapseAllTrigger, filterValue]);
    const shouldExpandNode: ShouldExpandNodeInitially = () => {
        // Check which action happened more recently
        if (expandAllTrigger > collapseAllTrigger) {
            return true;
        }
        if (collapseAllTrigger > expandAllTrigger) {
            return false;
        }
        // If there's a filter, expand all nodes to show matches
        if (filterValue.trim()) {
            return true;
        }
        // Otherwise, expand based on expandAll state
        return expandAll;
    };
    const handleExpandAll = () => {
        setExpandAllTrigger((prev) => prev + 1);
        setExpandAll(true);
    };
    const handleCollapseAll = () => {
        setCollapseAllTrigger((prev) => prev + 1);
        setExpandAll(false);
    };
    return (<>
            <div className={styles.controls}>
                <SearchInput value={filterValue} onChange={(value: string) => setFilterValue(value)} placeholder="Search tokens..." accessibleName="Filter color tokens"/>
                <Button importance="secondary" onClick={handleExpandAll} label="Expand All"/>
                <Button importance="secondary" onClick={handleCollapseAll} label="Collapse All"/>
            </div>
            <div className="json-tree-container" style={{ userSelect: "text" }}>
                <JSONTree key={treeKey} data={themeTokens.color} shouldExpandNodeInitially={shouldExpandNode} filterValue={filterValue}/>
            </div>
        </>);
}
const styles = {
    controls: css({
        display: "flex",
        gap: "10px",
        alignItems: "center",
    }),
};
